import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import config from "console_config";
import { Text } from "ds/Sticker";

import * as S from "../styles";

const PromptEnablObservabilitySuite = () => {
  const intl = useIntl();
  const blackfireSupportLanguages =
    config.CUSTOM_BLACKFIRE_CARD_LANGUAGE?.join(" or ");

  return (
    <S.BlackFireModalPrompt>
      <Typography.Title tag="h1" className="blackfire-prompt_title">
        {intl.formatMessage({
          id: "plans.blackfire.addon_add_prompt_continue_title"
        })}
      </Typography.Title>
      <Typography.BodyText>
        {intl.formatMessage(
          {
            id: "plans.blackfire.addon_add_prompt_continue_description"
          },
          {
            blackfireSupportLanguages
          }
        )}
      </Typography.BodyText>

      <Text as="p" className="blackfire-prompt_notice">
        {intl.formatMessage(
          {
            id: "plans.blackfire.addon_add_prompt_continue_description_note"
          },
          {
            a: chunks => (
              <a
                href={intl.formatMessage({
                  id: "blackfire.io"
                })}
                target="_blank"
                rel="noreferrer"
              >
                {chunks}
              </a>
            ),
            strong: chunks => <S.Note>{chunks}</S.Note>
          }
        )}
      </Text>
    </S.BlackFireModalPrompt>
  );
};

export default PromptEnablObservabilitySuite;
